import { render, staticRenderFns } from "./GruposPrecios.vue?vue&type=template&id=66008384"
import script from "./GruposPrecios.vue?vue&type=script&lang=js"
export * from "./GruposPrecios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports